export default __webpack_public_path__ + "static/media/45.a18d2989.gif";